import type { JSX } from "react";
import { Donut, GroupedBars } from "../charts.js";
import { COLOR, compact, LABEL, PROVIDERS, rangeText, useAnalytics } from "../data.js";
import { DatePill, PageHead, Seg } from "../ui.js";

function Legend(): JSX.Element {
  return <div className="cx-legend"><span><i className="claude" />Claude</span><span><i className="codex" />Codex</span></div>;
}

export function Stats({ days, onDays }: { days: number; onDays: (value: number) => void }): JSX.Element {
  const { data, error } = useAnalytics(days);
  const claude = data?.providers.find((item) => item.provider === "claude");
  const codex = data?.providers.find((item) => item.provider === "codex");
  const totals = PROVIDERS.map((provider) => {
    const points = data?.providers.find((item) => item.provider === provider)?.points ?? [];
    return { provider, tokens: points.reduce((sum, point) => sum + point.tokens, 0) };
  });
  const sum = totals.reduce((acc, item) => acc + item.tokens, 0);
  return (
    <>
      <PageHead title="模型对比" subtitle="对比不同模型的用量和成本" right={<>
        <Seg items={[[7, "7天"], [30, "30天"]] as const} value={days} onChange={onDays} />
        <DatePill text={rangeText(days, data)} />
      </>} />
      {error && <p className="cx-error">{error}</p>}
      <div className="cx-stats3 cx-fill">
        <section className="cx-card neutral cx-chart-card">
          <header className="cx-card-head small"><h2>Token 使用量对比</h2></header>
          <Legend />
          <GroupedBars claude={claude?.points ?? []} codex={codex?.points ?? []} value="tokens" />
        </section>
        <section className="cx-card neutral cx-chart-card">
          <header className="cx-card-head small"><h2>费用对比 (USD)</h2></header>
          <Legend />
          <GroupedBars claude={claude?.points ?? []} codex={codex?.points ?? []} value="costUsd" />
        </section>
        <section className="cx-card neutral cx-share">
          <header className="cx-card-head small"><h2>总用量占比 ({days}天)</h2></header>
          <Donut segments={totals.map((item) => ({ key: item.provider, value: item.tokens, color: COLOR[item.provider] }))} centre={compact(sum)} caption="总 Token" />
          <div className="cx-share-legend">
            {totals.map((item) => (
              <div key={item.provider}>
                <span><i className={item.provider} />{LABEL[item.provider]}</span>
                <b>{sum > 0 ? `${((item.tokens / sum) * 100).toFixed(1)}%` : "--"}</b>
                <small>{compact(item.tokens)}</small>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
}
